export default {
	Title: 'Bạn có hài lòng về MISA meInvoice - Xử lý hóa đơn và chia sẻ  sản phẩm với mọi người?',
	SurveyEvaluate: 'Đánh giá sự hài lòng và sẵn sàng chia sẻ MISA meInvoice - Xử lý hóa đơn đến mọi người:',
	VerySatisfied: 'Rất hài lòng',
	Unsatisfied: 'Không hài lòng',
	Opinion: 'Ý kiến đóng góp',
	Close: 'Đóng',
	SendFeedback: 'Gửi phản hồi',
	TextThanks:
		'Những nhận xét, đánh giá của bạn sẽ rất hữu ích trong quá trình cải tiến và phát triển sát phẩm để mang đến cho bạn trải nghiệm tốt nhất.',
	ReasonUnsatisfied: 'Xin cho biết lý do bạn chưa hài lòng với sản phẩm',
	ThankOption: 'Cảm ơn bạn đã tin tưởng, bạn muốn góp ý gì để sản phẩm ngày càng tốt hơn?',
	Send: 'Gửi',
	Cancel: 'Hủy bỏ',
	Thanks: 'Cảm ơn bạn',
	EvaluationScore: 'Điểm đánh giá',
	QuestionOption: 'Ý kiến đóng góp thêm (nếu có)?',
	ReasonType: 'Loại lý do?',

	//Bo sung
	YourOpinion: 'Ý kiến của bạn',
	NeedVoteBeforeSend: 'Bạn cần chấm điểm mức độ hài lòng trước khi gửi phản hồi',
	RatingTemporarilyUnavailableMessage: "Chức năng đánh giá đang tạm thời gián đoạn. Vui lòng thử lại sau ít phút.",
	RatingActionFailedTitle: "Không thực hiện được chức năng đánh giá"
};
